import type { AxiosError } from 'axios';
import axios from 'axios';
import type { ApiBaseResponse } from '@hotjar/webapp/domains/common/api';
import type { AccessRequest, AccessRequestResponse } from './model';
import type { RequestAccessDto } from './dto';
import { mapAccessRequestModelToDto, mapRequestAccessDtoToModel } from './mapper';

export const ERRORS = {
  ALREADY_SENT: 'already-sent',
  ALREADY_HAS_ACCESS: 'email_already_has_access',
  UNKNOWN_ORGANIZATION: 'unknown_organization',
  TOO_MANY_ATTEMPTS: 'too-many-attempts',
  UNKNOWN: 'unknown',
};

const handleOn400 = (error: AxiosError) => {
  switch (error?.response?.data?.error) {
    case ERRORS.ALREADY_HAS_ACCESS:
      throw new Error(ERRORS.ALREADY_HAS_ACCESS);
    case ERRORS.UNKNOWN_ORGANIZATION:
      throw new Error(ERRORS.UNKNOWN_ORGANIZATION);
    default:
      throw new Error(ERRORS.UNKNOWN);
  }
};

export async function requestAccess(data: AccessRequest): Promise<ApiBaseResponse> {
  try {
    const response = await axios.post<ApiBaseResponse>(
      `/api/v1/request-access`,
      mapAccessRequestModelToDto(data),
    );
    return response.data;
  } catch (error) {
    switch ((error as AxiosError)?.response?.status) {
      case 422:
        throw new Error(ERRORS.ALREADY_SENT);
      case 429:
        throw new Error(ERRORS.TOO_MANY_ATTEMPTS);
      case 400:
        return handleOn400(error as AxiosError);
      default:
        throw new Error(ERRORS.UNKNOWN);
    }
  }
}

export async function getRequestAccessData(token: string): Promise<AccessRequestResponse> {
  const response = await axios.get<RequestAccessDto>(`/api/v1/request-access/${token}`);
  return mapRequestAccessDtoToModel(response.data);
}
